/*
 * @Author: your name
 * @Date: 2021-06-10 09:28:07
 * @LastEditTime: 2021-08-05 17:23:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\router\modules\order.js
 */
/**
 * 订单路由
 */
export default [
  {
    path: '/orderList',
    component: resolve => require(['../../views/order/orderList'], resolve),
    meta: { title: '我的订单' }
  },
  {
    path: '/outSystemOrderList',
    component: resolve => require(['../../views/order/outSystemOrderList'], resolve),
    meta: { title: '系统外订单列表' }  //门店
  },  
  {
    path: '/outSystemHeadList',
    component: resolve => require(['../../views/order/outSystemHeadList'], resolve),
    meta: { title: '系统外订单列表' }  //总部
  },  
  {
    path: '/order/travelService',
    component: resolve => require(['../../views/order/travelService'], resolve),
    meta: { title: '常用旅客' }
  },
  {
    path: '/order/addOrder',
    component: resolve => require(['../../views/order/addOrder'], resolve),
    meta: { title: '新增散客订单' }
  },
  {
    path: '/order/addErpOrder',
    component: resolve => require(['../../views/order/addErpOrder'], resolve),
    meta: { title: '新增散客订单' }
  },
  {
    path: '/order/addOutOfSystemOrder',
    component: resolve => require(['../../views/order/addOutOfSystemOrder'], resolve),
    meta: { title: '新增系统外订单' }
  },  
  {
    path: '/order/confirmOutOfSystemOrder',
    component: resolve => require(['../../views/order/confirmOutOfSystemOrder'], resolve),
    meta: { title: '确认系统外订单' }
  }, 
  {
    path: '/order/headOrgSetSettlement',
    component: resolve => require(['../../views/order/headOrgSetSettlement'], resolve),
    meta: { title: '编辑结算' }  //总部
  },
  {
    path: '/orderDetails',
    component: resolve => require(['../../views/order/orderDetails'], resolve),
    meta: { title: '订单详情' }
  },
  {
    path: '/confirmOrder',
    component: resolve => require(['../../views/order/confirmOrder'], resolve),
    meta: { title: '确认订单' }
  },
  {
    path: '/order/confirmOrderList',
    component: resolve => require(['../../views/order/confirmOrderList'], resolve),
    meta: { title: '确认单列表' }
  },
  {
    path: '/order/confirmOrderListShop',
    component: resolve => require(['../../views/order/confirmOrderList'], resolve),
    meta: { title: '确认单列表' }
  },
  {
    path: '/order/confirmOrderBatch',
    component: resolve => require(['../../../owncomponents/order/order-confirm-batch'], resolve),
    meta: { title: '批量确认单列表' }
  },
  {
    path: '/order/confirmOrderDetail',
    component: resolve => require(['../../../owncomponents/order/order-confirm-view'], resolve),
    meta: { title: '确认单详情' }
  },
  
  {
    path: '/order/orderPay',
    component: resolve => require(['../../views/order/orderPay'], resolve),
    meta: { title: '付款' }
  },
  {
    path: '/order/teamPayment',
    component: resolve => require(['../../views/order/teamPayment'], resolve),
    meta: { title: '付款' }
  },
  {
    path: '/handleChange',
    component: resolve => require(['../../views/order/handleChange'], resolve),
    meta: { title: '处理变更' }
  },
  {
    path: '/order/groupOrder',
    component: resolve => require(['../../views/order/groupOrder'], resolve),
    meta: { title: '我的组订单' }
  },
  {
    path: '/order/teamGroupOrder',
    component: resolve => require(['../../views/order/teamGroupOrder'], resolve),
    meta: { title: '我的组订单' }
  },
  {
    path: '/order/leavingSdes',
    component: resolve => require(['../../views/order/leavingSdes'], resolve),
    meta: { title: '出团通知书' }
  },
  {
    path: '/order/orderConfirmation',
    component: resolve => require(['../../views/order/orderConfirmation'], resolve),
    meta: { title: '订单转正' }
  },
  {
    path: '/order/orderApplyChange',
    component: resolve => require(['../../views/order/orderApplyChange'], resolve),
    meta: { title: '申请变更' }
  },
  {
    path: '/order/orderApplyChangeErp',
    component: resolve => require(['../../views/order/orderApplyChangeErp'], resolve),
    meta: { title: '申请变更' }
  },

  {
    path: '/order/handleChange',
    component: resolve => require(['../../views/order/handleChange'], resolve),
    meta: { title: '处理变更' }
  },
  {
    path: '/order/teamOrderList',
    component: resolve => require(['../../views/order/teamOrderList'], resolve),
    meta: { title: '我的团队订单' }
  },
  {
    path: '/order/teamAddOrder',
    component: resolve => require(['../../views/order/teamAddOrder'], resolve),
    meta: { title: '新增团队订单' }
  },
  {
    path: '/order/provisionalOrder',
    component: resolve => require(['../../views/order/provisionalOrder'], resolve),
    meta: { title: '申请变更' }
  },
  {
    path: '/order/teamOrderApplyChange',
    component: resolve => require(['../../views/order/teamOrderApplyChange'], resolve),
    meta: { title: '团队订单申请变更' }
  },
  {
    path: '/order/outSystemOrderApplyChange',
    component: resolve => require(['../../views/order/outSystemOrderApplyChange'], resolve),
    meta: { title: '系统外订单申请变更' }
  },  
  {
    path: '/order/teamPoraryOrderChange',
    component: resolve => require(['../../views/order/teamPoraryOrderChange'], resolve),
    meta: { title: '团队临时订单申请变更' }
  },
  {
    path: '/order/teamOrderDetails',
    component: resolve => require(['../../views/order/teamOrderDetails'], resolve),
    meta: { title: '订单详情' }
  },
  {
    path: '/order/reviewOrder',
    component: resolve => require(['../../views/order/reviewOrder'], resolve),
    meta: { title: '审核订单' }
  },
  {
    path: '/order/managerReview',
    component: resolve => require(['../../views/order/managerReview'], resolve),
    meta: { title: '审核订单' }
  },
  {
    path: '/order/teamOrderConfirmation',
    component: resolve => require(['../../views/order/teamOrderConfirmation'], resolve),
    meta: { title: '团队订单转正' }
  },
  {
    path: '/order/temporaryOrderapplychange',
    component: resolve => require(['../../views/order/temporaryOrderapplychange'], resolve),
    meta: { title: '团队订单变更' }
  },
  {
    path: '/order/teamPayment',
    component: resolve => require(['../../views/order/teamPayment'], resolve),
    meta: { title: '付款' }
  },
  {
    path: '/order/confirmTeamOrder',
    component: resolve => require(['../../views/order/confirmTeamOrder'], resolve),
    meta: { title: '确认订单' }
  },
  {
    path:'/createImg',
    component: resolve => require(['../../views/order/createShopImg.vue'], resolve),
    meta: { title: '生成图片' }
  },
  {
    path:'/order/orderProductDetail',
    component: resolve => require(['../../views/order/orderProductDetail.vue'], resolve),
    meta: { title: '产品详情' }
  },
  {
    path:'/mall/mallOrder',
    component: resolve => require(['../../views/mall/mallOrder.vue'], resolve),
    meta: { title: '商城订单' }
  },
  {
    path:'/mall/mallCommission',
    component: resolve => require(['../../views/mall/mallCommission.vue'], resolve),
    meta: { title: '商城佣金' }
  },
  {
    path:'/mall/mallOrderDetails',
    component: resolve => require(['../../views/mall/mallOrderDetails.vue'], resolve),
    meta: { title: '订单详情' }
  },
  {
    path:'/order/InitiateActionsPage',
    component: resolve => require(['../../views/order/InitiateActionsPage.vue'], resolve),
    meta: { title: '发起决算' }
  },
  {
    path:'/awaitOrder/awaitOrderList',
    component: resolve => require(['../../views/awaitOrder/awaitOrderList.vue'], resolve),
    meta: { title: '待订单列表' }
  },
  {
    path:'/awaitOrder/awaitOrderListHeader',
    component: resolve => require(['../../views/awaitOrder/awaitOrderListHeader.vue'], resolve),
    meta: { title: '总部待订单列表' }
  },
]



// WEBPACK FOOTER //
// ./src/TASMini/router/modules/order.js